import { useSelector } from 'react-redux';

const useProjectSelector = () => useSelector(({ project }) => project.present);

export { useProjectSelector };
